<template>
    <div
        v-if="doctor !== null && scheduleTimezone !== null"
        class="card vc-exception-schedule-table">
        <div class="card-header">例外スケジュール</div>

        <div class="card-body">
            <div class="row">
                <div class="col">
                    <FullCalendar
                        id="calendar"
                        class="calendar-wrapper mb-3"
                        ref="fullCalendar"
                        :plugins="calendarPlugins"
                        :default-view="config.fullCalendar.defaultView"
                        :header="config.fullCalendar.header"
                        :height="config.fullCalendar.height"
                        :locale="config.fullCalendar.locale"
                        :events="fullCalendarEvents"
                        :event-text-color="config.fullCalendar.eventTextColor"
                        :valid-range="config.fullCalendar.validRange"
                        :show-non-current-dates="config.fullCalendar.showNonCurrentDates"
                        :all-day-slot="config.fullCalendar.allDaySlot"
                        :display-event-end="config.fullCalendar.displayEventEnd"
                        :editable="config.fullCalendar.editable"
                        :selectable="config.fullCalendar.selectable"
                        :event-time-format="config.fullCalendar.eventTimeFormat"
                        @dateClick="dateClick"
                        :dates-render="datesRender"
                        @eventClick="onEventClick">
                    </FullCalendar>
                </div>
            </div>
        </div>

        <b-modal
            v-model="modalShow"
            id="modalExceptionSchedule"
            :title="`${selectedDate.format( 'YYYY年M月D日' )}の例外スケジュール登録`"
            size="xl"
            static
            @ok="handleOk"
            :ok-only="true"
            ok-title="登録"
            ok-variant="yokumiru-orange">
            <form @submit.stop.prevent="postSchedule">
                <div class="small">
                    <ul class="pl-3">
                        <li>例外スケジュールを登録すると、その日の基本スケジュールは無視されます。</li>
                        <li>チェックなしの時間帯は「休診」&nbsp;チェックありの時間帯は「{{ $locale.consultation_host }}」となります。</li>
                        <li>すでに予約が入ってる場合はチェックを外せません。</li>
                    </ul>
                </div>

                <div class="d-flex justify-content-center">
                    <div
                        v-for="(col, colIdx) in checkSchedule.checkboxes[intervalIdx]"
                        class="ml-3 mr-3">
                        <div>
                            <input
                                type="checkbox"
                                class="ex-check-col-all"
                                :id="`ex-col${colIdx}`"
                                :value="colIdx"
                                :checked="existsCheckedIdx(colIdx)"
                                :disabled="disableCol(checkSchedule)"
                                @change="toggleColumnAll(checkSchedule, col, colIdx, $event)">
                            <label
                                :for="`ex-col${colIdx}`"
                                :class="{ disabled : disableCol(checkSchedule) }">
                                {{ `${timeForHuman(col[0].start_time.slice(0, -3))} - ${timeForHuman(col[ col.length - 1 ].end_time.slice(0, -3), false)}` }}
                            </label>
                        </div>

                        <hr class="mt-0 mb-2">

                        <template v-for="(row, rowIdx) in col">
                            <div>
                                <input
                                    type="checkbox"
                                    :id="`ex-${row.start_time}-${rowIdx}`"
                                    :value="row"
                                    :disabled="disableRow(checkSchedule, row)"
                                    @change="changeColumnState(row)"
                                    v-model="checkSchedule.selectedData">
                                <label
                                    :for="`ex-${row.start_time}-${rowIdx}`"
                                    :class="{ disabled: disableRow(checkSchedule, row), base_schedule: isBasicSchedule(row, selectedDate) }">
                                    {{ `${timeForHuman(row.start_time.slice(0, -3))} - ${timeForHuman(row.end_time.slice(0, -3), false)}` }}
                                </label>
                            </div>
                        </template>
                    </div>
                </div>

                <div class="d-flex justify-content-between align-items-center mt-3">
                    <div class="base_schedule_remark small">
                        <div></div>
                        <div>&nbsp;:&nbsp;基本スケジュール</div>
                    </div>
                    <div class="">
                        <input
                            v-model="checkSchedule.isCloseAll"
                            id="isCloseAll"
                            name="isCloseAll"
                            type="checkbox"
                            @change="() => { checkSchedule.selectedData = []; checkedColumnAllList = []; }">
                        <label for="isCloseAll">終日休診にする</label>
                    </div>
                </div>
            </form>
        </b-modal>

        <b-modal
            v-if="doctor.google_calendar !== null"
            v-model="eventModalShow"
            static
            size="sm"
            hide-footer
            ok-variant="yokumiru-gray">
            <div class="d-flex justify-content-start align-items-start flex-column">
                <div class=" mx-auto">
                    <div class="d-flex modal-account">
                        <b-icon-calendar-fill class="my-auto"/>
                        <div class="ml-2">{{ doctor.google_calendar.google_calendar_summary }}</div>
                    </div>
                    <div class="modal-time">
                        <span v-if="googleEvent.isAllDay">終日休診</span>
                        <span v-else>{{ googleEventModalFormat(googleEvent) }}</span>
                    </div>
                    <div class="modal-summary">{{ googleEvent.summary }}</div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import constants from '../../constants'
    import moment from 'moment-timezone'
    import YokumiruHelper from '../../YokumiruHelper'

    import FullCalendar from '@fullcalendar/vue'
    import dayGridPlugin from '@fullcalendar/daygrid'
    import timeGridPlugin from '@fullcalendar/timegrid'
    import interactionPlugin from '@fullcalendar/interaction'
    import ja from '@fullcalendar/core/locales/ja'
    import '@fullcalendar/core/main.css'
    import '@fullcalendar/daygrid/main.css'
    import '@fullcalendar/timegrid/main.css'

    export default {
        components: {
            FullCalendar,
        },

        data: function() {
            return {
                helper: YokumiruHelper,
                modalShow: false,
                eventModalShow: false,
                googleEvent: {},
                inProgress: false,
                doctor: null,
                scheduleTimezone: null,
                basicSchedules: [],
                exceptionSchedules: [],
                calendarPlugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
                fullCalendarEvents: [],
                checkSchedule: {
                    checkboxes: [],
                    selectedData: [],
                    columnHours: constants.column_hours,
                    isCloseAll: false,
                },
                checkedColumnAllList: [],
                selectedDate: moment(),
                errors: {},
                savedMessage: '例外スケジュールを保存しました。',
                config: {
                    fullCalendar: {
                        locale: ja,
                        header: {
                            left: 'prev',
                            center: 'title',
                            right: 'next',
                        },
                        titleFormat: 'YYYY年M月',
                        defaultView: 'dayGridMonth',
                        eventTimeFormat: {
                            hour: '2-digit',
                            minute: '2-digit',
                        },
                        displayEventEnd: true,
                        editable: false,
                        selectable: false,
                        allDaySlot: false,
                        showNonCurrentDates: false,
                        validRange: {
                            start: moment().startOf('month').format('YYYY-MM-DD'),
                            end: null,
                        },
                    },
                },
                tooltipVisible: false,
                hoveredEventId: null,
                hoveredEventTitle: '',
            };
        },

        created: async function () {
            await this.fetchMe()
            await this.fetchBasicSchedules()
            await this.fetchExceptionSchedules()

            this.bindFullCalendar()

            bus.$on('change-link-calendar', this.changeLinkCalendar)
            bus.$on('stored-basic-schedule', this.refreshCalendar)
            bus.$on('schedule-timezone-confirmed', this.refreshCalendar)
            bus.$on('schedule-timezone-canceled', this.initScheduleTimezone)
        },

        beforeDestroy: function () {
            bus.$off('change-link-calendar')
            bus.$off('stored-basic-schedule')
            bus.$off('schedule-timezone-confirmed')
            bus.$off('schedule-timezone-canceled')
        },

        methods: {
            /**
             * ログイン医師取得
             */
            fetchMe: function () {
                return axios.get(constants.doctor.me.endpoint.base)
                    .then(({data}) => {
                        this.doctor = data.data
                        this.initScheduleTimezone()
                    })
            },

            /**
             * スケジュールのタイムゾーンをセット
             */
            initScheduleTimezone: function() {
                this.scheduleTimezone = this.doctor.doctor_metadata.schedule_timezone
            },

            /**
             * 基本スケジュール取得
             */
            fetchBasicSchedules: function () {
                return axios.get(`${constants.doctor.schedules.endpoint.base}/raw`)
                    .then(({data}) => {
                        this.basicSchedules = this.convertSchedulesFromJST(data.data)
                    })
            },

            /**
             * 例外スケジュール取得
             */
            fetchExceptionSchedules: function () {
                this.exceptionSchedules = []

                return axios.get(`${constants.doctor.exception_schedules.endpoint.base}/raw`)
                    .then(({data}) => {
                        this.exceptionSchedules = this.convertExceptionSchedulesFromJST(data.data)
                    })
            },

            /**
             * 基本スケジュールの時差変換処理
             * @see https://github.com/sewii/Yokumiru/issues/389
             * @param {array} schedules
             */
            convertSchedulesFromJST: function (schedules) {
                if (schedules.length < 1) return []

                const now = moment()
                const doctorOffset = now.clone().tz(schedules[0].timezone).utcOffset()
                const jstOffset = now.clone().tz('Asia/Tokyo').utcOffset()
                const diff = Math.abs(jstOffset - doctorOffset)
                const isGreaterThanJST = doctorOffset > jstOffset

                return schedules.map((schedule) => {
                    if (isGreaterThanJST) {
                        const start = moment(now.format(`YYYY-MM-DD ${schedule.start_time}`))
                        const end = moment(now.format(`YYYY-MM-DD ${schedule.end_time}`))
                        while (start.day() !== schedule.day) {
                            start.add(1, 'days')
                            end.add(1, 'days')
                        }
                        start.add(diff, 'minutes')
                        end.add(diff, 'minutes')

                        schedule.day = start.day()
                        schedule.start_time = start.format('HH:mm:00')
                        schedule.end_time = end.format('HH:mm:00')
                        if (schedule.end_time === '00:00:00') schedule.end_time = '24:00:00'
                    }
                    else {
                        const start = moment(now.format(`YYYY-MM-DD ${schedule.start_time}`))
                        const end = moment(now.format(`YYYY-MM-DD ${schedule.end_time}`))
                        while (start.day() !== schedule.day) {
                            start.add(1, 'days')
                            end.add(1, 'days')
                        }
                        start.subtract(diff, 'minutes')
                        end.subtract(diff, 'minutes')

                        schedule.day = start.day()
                        schedule.start_time = start.format('HH:mm:00')
                        schedule.end_time = end.format('HH:mm:00')
                        if (schedule.end_time === '00:00:00') schedule.end_time = '24:00:00'
                    }
                    return schedule
                })
            },

            /**
             * 例外スケジュールの時差変換処理
             * @see https://github.com/sewii/Yokumiru/issues/389
             * @param {array} schedules
             */
            convertExceptionSchedulesFromJST: function (schedules) {
                if (schedules.length < 1) return []

                return schedules.map((schedule) => {
                    // start の diff を使用する
                    const dateFormat = schedule.schedule_date.replace(' 00:00:00', '')
                    const date = moment(`${dateFormat} ${schedule.start_time}`)
                    const doctorOffset = date.clone().tz(schedule.timezone).utcOffset()
                    const jstOffset = date.clone().tz('Asia/Tokyo').utcOffset()
                    const diff = Math.abs(jstOffset - doctorOffset)
                    const isGreaterThanJST = doctorOffset > jstOffset

                    let endDiff = diff
                    if (schedule.is_google_event) {
                        // Googleカレンダーから連携された休診は start, end それぞれの diff を使用する
                        const endDate = moment(`${dateFormat} ${schedule.end_time}`)
                        const endDoctorOffset = endDate.clone().tz(schedule.timezone).utcOffset()
                        const endJstOffset = endDate.clone().tz('Asia/Tokyo').utcOffset()
                        endDiff = Math.abs(endJstOffset - endDoctorOffset)
                    }

                    if (isGreaterThanJST) {
                        schedule.schedule_date = moment(`${dateFormat} ${schedule.start_time}`).add(diff, 'minutes').format('YYYY-MM-DD')
                        schedule.start_time = moment(`${dateFormat} ${schedule.start_time}`).add(diff, 'minutes').format('HH:mm:00')
                        schedule.end_time = moment(`${dateFormat} ${schedule.end_time}`).add(endDiff, 'minutes').format('HH:mm:00')
                        if (schedule.end_time === '00:00:00') schedule.end_time = '24:00:00'
                    }
                    else {
                        schedule.schedule_date = moment(`${dateFormat} ${schedule.start_time}`).subtract(diff, 'minutes').format('YYYY-MM-DD')
                        schedule.start_time = moment(`${dateFormat} ${schedule.start_time}`).subtract(diff, 'minutes').format('HH:mm:00')
                        schedule.end_time = moment(`${dateFormat} ${schedule.end_time}`).subtract(endDiff, 'minutes').format('HH:mm:00')
                        if (schedule.end_time === '00:00:00') schedule.end_time = '24:00:00'
                    }
                    return schedule
                })
            },

            /**
             * [FullCalendar]
             * レンダリング完了時
             *
             * @see https://fullcalendar.io/docs/datesRender
             */
            datesRender: function ({view}) {
                //「◯日」の「日」を削除
                $('span.fc-day-number').each(function () {
                    if (this.innerText.includes('日')) {
                        this.innerText = this.innerText.slice(0, -1)
                    }
                })
            },

            /**
             * 日付表記フォーマット
             *
             * @param {object} data
             * @return {string}
             */
            dateForHuman: function (data) {
                return moment(data.schedule_date).format('YYYY年M月D日')
            },

            /**
             * 曜日表記フォーマット
             *
             * @param {object} data
             * @return {string}
             */
            dayForHuman: function (data) {
                return constants.days[moment(data.schedule_date).day()]
            },

            /**
             * 曜日表記CSS
             *
             * @param {object} data
             * @return {string}
             */
            dayForHumanCSS: function (data) {
                const day = moment(data.schedule_date).day()

                if (day === 0) return 'text-danger'
                if (day === 6) return 'text-yokumiru-blue'

                return ''
            },

            /**
             * 午前・午後表記フォーマット
             *
             * @param {string} time
             * @param {boolean} isDisplayAmPm
             * @return {string}
             */
            timeForHuman: function (time, isDisplayAmPm = true) {
                const hour = Number(time.substring(0, 2))
                const minutes = time.substring(3, 5)

                if (hour < 12) {
                    return isDisplayAmPm ? `午前${time}` : time
                }

                let format = ''
                if (hour === 12) {
                    format = `12:${minutes}`
                } else if (hour === 13) {
                    format = `01:${minutes}`
                } else if (hour === 14) {
                    format = `02:${minutes}`
                } else if (hour === 15) {
                    format = `03:${minutes}`
                } else if (hour === 16) {
                    format = `04:${minutes}`
                } else if (hour === 17) {
                    format = `05:${minutes}`
                } else if (hour === 18) {
                    format = `06:${minutes}`
                } else if (hour === 19) {
                    format = `07:${minutes}`
                } else if (hour === 20) {
                    format = `08:${minutes}`
                } else if (hour === 21) {
                    format = `09:${minutes}`
                } else if (hour === 22) {
                    format = `10:${minutes}`
                } else if (hour === 23) {
                    format = `11:${minutes}`
                } else if (hour === 24) {
                    format = `00:${minutes}`
                }

                if (isDisplayAmPm) {
                    return hour === 24 ? `午前${format}` : `午後${format}`
                }
                return format
            },

            /**
             * [vue-full-calendar]
             * CSSクラス名
             *
             * @param {object} schedule
             * @return {string}
             */
            timeForHumanCSS: function (schedule) {
                if (schedule.is_google_event > 0) {
                    return 'status status-google'
                }
                else if (schedule.flg_close > 0) {
                    return 'status status-close'
                }
                return 'status status-open'
            },

            /**
             * [vue-full-calendar]
             * 登録完了後の初期化
             */
            refreshCalendar: async function () {
                await this.fetchMe()
                await this.fetchBasicSchedules()
                await this.fetchExceptionSchedules()

                this.bindFullCalendar()

                this.$refs.fullCalendar.$emit('reload-events')
            },

            /**
             * 診療時間間隔に基づいて
             * チェックボックス列を作成
             */
            prepareCheckbox: function () {
                this.checkSchedule.checkboxes = []

                constants.minutes_intervals.forEach(minutes => {
                    let columns = []
                    let colIdx = 0

                    this.checkSchedule.columnHours.forEach(hour => {
                        const timeFrom = moment().hour(hour).minute(0).second(0)
                        const timeTo = moment().hour(hour + 4).minute(0).second(0)

                        let rows = []

                        while (timeTo.diff(timeFrom, 'minute') > 0) {
                            let start = timeFrom.format('HH:mm:ss')
                            let end = timeFrom.add(minutes, 'minutes').format('HH:mm:ss')
                            if (end === '00:00:00') end = '24:00:00'

                            rows.push({
                                schedule_date: this.selectedDate.format('YYYY-MM-DD'),
                                start_time: start,
                                end_time: end,
                                flg_reserved: false,
                                column_idx: colIdx,
                            })
                        }
                        columns.push(rows)
                        colIdx++
                    });

                    this.checkSchedule.checkboxes.push(columns)
                })
            },

            /**
             * チェックボックス列の
             * チェック状態初期化
             */
            initChecked: function () {
                this.checkSchedule.isCloseAll = false
                this.checkSchedule.selectedData = []
                this.checkedColumnAllList = []

                // 終日休診の場合
                if (this.isClosedAll) {
                    this.checkSchedule.isCloseAll = true
                    this.checkSchedule.selectedData = []
                    this.checkedColumnAllList = []
                    return
                }

                this.filteredSchedules.forEach((schedule) => {
                    if (schedule.is_google_event) return
                    if (schedule.flg_close === 1) return

                    const checkboxes = this.checkSchedule.checkboxes[this.intervalIdx]
                    checkboxes.forEach((col) => {
                        col.forEach((row) => {
                            if (row.end_time > schedule.start_time && row.start_time < schedule.end_time) {
                                if (!this.checkSchedule.selectedData.includes(row)) {
                                    this.checkSchedule.selectedData.push(row)
                                }
                            }
                        })
                        this.changeColumnState(col[0])
                    })
                })
            },

            /**
             * 全選択チェックボックスの状態制御
             *
             * @params {number} colIdx 列インデックス
             * @return {boolean}
             */
            existsCheckedIdx: function (colIdx) {
                return this.checkedColumnAllList.includes(colIdx)
            },

            /**
             * [vue-full-calendar]
             * イベント登録
             */
            bindFullCalendar: function () {
                const events = []
                const schedules = this.exceptionSchedules.filter((schedule) => !schedule.is_split)
                const splitSchedules = this.exceptionSchedules.filter((schedule) => schedule.is_split)

                schedules.forEach((schedule) => {
                    const tmpSchedule = {...schedule}
                    const splitSchedule = splitSchedules.find((s) => s.schedule_date === tmpSchedule.schedule_date && s.start_time === tmpSchedule.end_time)

                    if (splitSchedule) {
                        tmpSchedule.end_time = splitSchedule.end_time
                    }

                    let title = ''
                    if (tmpSchedule.flg_close > 0 && tmpSchedule.start_time === '00:00:00' && tmpSchedule.end_time === '24:00:00') {
                        title = '休診'
                    }
                    else {
                        title = `${this.timeForHuman(tmpSchedule.start_time.substring(0, 5))} - ${this.timeForHuman(tmpSchedule.end_time.substring(0, 5))}`
                    }

                    events.push({
                        id: tmpSchedule.id,
                        title: title,
                        start: `${tmpSchedule.schedule_date.substring(0, 10)} ${tmpSchedule.start_time}`,
                        end: `${tmpSchedule.schedule_date.substring(0, 10)} ${tmpSchedule.end_time}`,
                        className: [this.timeForHumanCSS(tmpSchedule)],
                        extendedProps: {
                            summary: schedule.google_event_summary,
                            is_google_event: schedule.is_google_event,
                        },
                    })
                })
                this.fullCalendarEvents = events
            },

            /**
             * 列全体のチェック状態を制御
             *
             * @param {object} row
             */
            changeColumnState: function (row) {
                const checkboxes = this.checkSchedule.checkboxes[this.intervalIdx]

                const countColumn = checkboxes[row.column_idx].length
                const countCheckedRow = this.checkSchedule.selectedData.filter((rowTarget) => rowTarget.column_idx === row.column_idx).length
                const idx = this.checkedColumnAllList.findIndex((val) => val === row.column_idx)

                if (countColumn < 1) return

                if (countCheckedRow >= countColumn && idx < 0) {
                    this.checkedColumnAllList.push(row.column_idx)
                }
                else if (countCheckedRow < countColumn && idx > -1) {
                    this.checkedColumnAllList.splice(idx, 1)
                }
            },

            /**
             * チェックボックス列
             * 全選択および全解除
             *
             * @param {object} checkSchedule
             * @param {array} col
             * @param {number} colIdx
             * @param {object} event
             */
            toggleColumnAll(checkSchedule, col, colIdx, event) {
                const $elem = event.target

                // 列のチェック制御
                col.forEach((row) => {
                    if ($elem.checked) {
                        // 全選択
                        if (!this.disableRow(checkSchedule, row) && !this.checkSchedule.selectedData.includes(row)) {
                            this.checkSchedule.selectedData.push(row)
                        }
                    }
                    else {
                        // 全解除
                        const idx = this.checkSchedule.selectedData.findIndex((data) => data === row)
                        if (idx > -1 && !this.checkSchedule.selectedData[idx].flg_reserved) {
                            this.checkSchedule.selectedData.splice(idx, 1)
                        }
                    }
                })

                // 全選択チェック自身の制御
                if ($elem.checked) {
                    if (!this.checkedColumnAllList.includes(colIdx)) {
                        this.checkedColumnAllList.push(colIdx)
                    }
                }
                else {
                    const idx = this.checkedColumnAllList.findIndex((val) => val === colIdx)
                    if (idx > -1) {
                        this.checkedColumnAllList.splice(idx, 1)
                    }
                }
            },

            /**
             * [vue-full-calendar]
             * 日付クリック時
             */
            dateClick: function ({dateStr, jsEvent}) {
                const clickDate = moment(dateStr.substring(0, 10) + " 00:00:00")
                const diff = Math.ceil(clickDate.diff(moment(), 'days', true))

                if (diff < 0) {
                    jsEvent.preventDefault()
                    return
                }

                this.selectedDate = clickDate
                this.prepareCheckbox()
                this.initChecked()
                this.modalShow = true
            },

            /**
             * モーダルウィンドウ
             * OKクリック時
             */
            handleOk: function (e) {
                e.preventDefault()
                this.postSchedule()
            },

            /**
             * 例外スケジュール保存
             */
            postSchedule: async function() {
                if (this.inProgress) return
                this.inProgress = true

                const endpoints = constants.doctor.exception_schedules.endpoint
                let data, endpoint

                if (this.checkSchedule.selectedData.length > 0) {
                    // 保存
                    endpoint = endpoints.base
                    data = {
                        schedule_date: this.selectedDate.format('YYYY-MM-DD'),
                        schedules: this.preparePostSchedules(),
                        timezone: this.scheduleTimezone,
                        is_registered_dst: this.helper.isUserSummerTimeNow(this.scheduleTimezone)
                    }
                }
                else if (this.checkSchedule.isCloseAll) {
                    // 保存（終日休診）
                    endpoint = endpoints.storeClose
                    data = {
                        schedule_date: this.selectedDate.format('YYYY-MM-DD'),
                        timezone: this.scheduleTimezone,
                        is_registered_dst: this.helper.isUserSummerTimeNow(this.scheduleTimezone)
                    }
                }
                else {
                    // 削除（選択日）
                    endpoint = endpoints.delete
                    data = {
                        schedule_date: this.selectedDate.format('YYYY-MM-DD'),
                        timezone: this.scheduleTimezone,
                    }
                }

                await axios.post(endpoint, data)
                    .then(() => {
                        bus.$emit('alert-success', '例外スケジュールを保存しました。')
                        this.refreshCalendar()
                        this.errors = {}
                        this.modalShow = false
                    })
                    .catch(({response}) => {
                        if (response &&
                            response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            bus.$emit('alert-danger')
                            this.errors = response.data.errors
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })

                this.inProgress = false
            },

            /**
             * 例外スケジュール保存リクエスト用のデータ準備
             * @return {array}
             */
             preparePostSchedules: function () {
                const result = []
                let isSplit = false

                // 時間で昇順ソートする（意図しない is_split の発生を防ぐ）
                const sortedData = this.checkSchedule.selectedData.sort((a, b) => {
                    if (a.start_time < b.start_time) return -1
                    if (a.start_time > b.start_time) return 1
                    return 0
                })

                sortedData.forEach((sd) => {
                    const data = {...sd}
                    const start = this.helper.jstTime(`${sd.schedule_date} ${sd.start_time}`, this.scheduleTimezone)
                    let end = this.helper.jstTime(`${sd.schedule_date} ${sd.end_time}`, this.scheduleTimezone)

                    data.schedule_date = start.format('YYYY-MM-DD')
                    data.start_time = start.format('HH:mm:00')
                    data.end_time = end.format('HH:mm:00')

                    if (isSplit) {
                        if (data.start_time === '00:00:00') {
                            data.is_split = true
                        }
                        isSplit = false
                    }

                    if (data.start_time > data.end_time) {
                        data.end_time = '24:00:00'
                        result.push(data)
                        isSplit = true
                    }
                    else {
                        result.push(data)
                    }
                })

                return result
            },

            /**
             * 基本スケジュールの時間帯判定
             *
             * @param {object} row
             * @param {moment} date
             *
             * @return boolean
             */
            isBasicSchedule: function (row, date) {
                const result = this.basicSchedules.find((schedule) => {
                    if (schedule.day === date.day()) {
                        return row.end_time > schedule.start_time && row.start_time < schedule.end_time
                    }
                    return false
                })

                return !!result
            },

            /**
             * checkbox 列チェック不可判定
             * @param {object} checkSchedule
             * @return {boolean}
             */
            disableCol: function (checkSchedule) {
                return checkSchedule.isCloseAll
            },

            /**
             * checkbox 行チェック不可判定
             * @param {object} checkSchedule
             * @param {array} row
             * @return {boolean}
             */
            disableRow: function (checkSchedule, row) {
                return checkSchedule.isCloseAll
                    || this.isIncludeGoogleSchedule(row)
                    || this.isIncludeCloseSchedule(row)
                    || this.isAcrossDstRow(row)
            },

            /**
             * Googleカレンダー連携された休診の時間帯と被る行判定
             * @param {object} row
             * @return {boolean}
             */
            isIncludeGoogleSchedule: function (row) {
                const start = moment.tz(`${row.schedule_date} ${row.start_time}`, this.scheduleTimezone)
                const end = moment.tz(`${row.schedule_date} ${row.end_time}`, this.scheduleTimezone)

                return this.filteredGoogleSchedules.some((googleSchedule) => {
                    const gStart = moment.tz(`${googleSchedule.schedule_date} ${googleSchedule.start_time}`, this.scheduleTimezone)
                    const gEnd = moment.tz(`${googleSchedule.schedule_date} ${googleSchedule.end_time}`, this.scheduleTimezone)
                    return start.isBefore(gEnd) && end.isAfter(gStart)
                })
            },

            /**
             * 休診の時間帯と被る行判定
             * @param {object} row
             * @return {boolean}
             */
            isIncludeCloseSchedule: function (row) {
                const start = moment.tz(`${row.schedule_date} ${row.start_time}`, this.scheduleTimezone)
                const end = moment.tz(`${row.schedule_date} ${row.end_time}`, this.scheduleTimezone)

                return this.filteredCloseSchedules.some((s) => {
                    const gStart = moment.tz(`${s.schedule_date} ${s.start_time}`, this.scheduleTimezone)
                    const gEnd = moment.tz(`${s.schedule_date} ${s.end_time}`, this.scheduleTimezone)
                    return start.isBefore(gEnd) && end.isAfter(gStart)
                })
            },

            /**
             * サマータイムと冬時間を跨ぐ行判定
             * @param {object} row
             * @return {boolean}
             */
            isAcrossDstRow: function (row) {
                const start = moment.tz(`${row.schedule_date} ${row.start_time}`, this.scheduleTimezone)
                const end = moment.tz(`${row.schedule_date} ${row.end_time}`, this.scheduleTimezone)

                if (!start.isDST() && !end.isDST()) {
                    return false
                }

                const startHourPrevTick = moment.tz(`${row.schedule_date} ${row.start_time}`, this.scheduleTimezone).minutes(0).subtract(1, 'minutes')
                const endHourNextTick = moment.tz(`${row.schedule_date} ${row.end_time}`, this.scheduleTimezone).minutes(59).add(1, 'minutes')

                const isPrevDst = startHourPrevTick.isDST()
                const isNextDst = endHourNextTick.isDST()

                if (isPrevDst === isNextDst) {
                    return false
                }

                if (isPrevDst) {
                    // サマータイムから冬時間に戻るケース
                    const endNext1Hour = moment.tz(`${row.schedule_date} ${row.end_time}`, this.scheduleTimezone).add(1, 'hour')
                    const jstEnd = moment(`${row.schedule_date} ${row.end_time}`)
                    const jstEndPrev1Hour = moment(endNext1Hour.format('YYYY-MM-DD HH:mm:ss'))

                    return Math.abs(jstEnd.diff(jstEndPrev1Hour, 'hours')) === 1
                }
                else {
                    // 冬時間からサマータイムに入るケース
                    const startPrev1Hour = moment.tz(`${row.schedule_date} ${row.start_time}`, this.scheduleTimezone).subtract(1, 'hour')
                    const jstStart = moment(`${row.schedule_date} ${row.start_time}`)
                    const jstStartPrev1Hour = moment(startPrev1Hour.format('YYYY-MM-DD HH:mm:ss'))

                    return Math.abs(jstStart.diff(jstStartPrev1Hour, 'hours')) === 1
                }

                // サマータイムと冬時間を跨ぐ行でも disabled しないことが理想だが、そうなると以下のようなケース対応が発生する
                //
                // 【ケース1】アテネ時間は JST-7 であり、2025年3月30日 03:00 にサマータイムへ突入する
                //      現地時間 02:30 - 03:00 は、JST 09:30 - 10:00 となるが、現地時間 03:30 - 04:00 も同じ時間になる。
                //      したがって、現地時間 02:30 - 03:00 は許容し、03:00 - 04:00 は disabled にする。
                //
                // 【ケース2】シドニー時間は JST+2 であり、2025年4月6日 03:00 にサマータイムが終了する
                //     現地時間の 02:30 - 03:00 について、start, end それぞれにおける時差を基準にJSTに直すと 00:30 - 02:00 となり、1時間伸びてしまう
                //     このようなケースにおいては start の時差のみで JST に直す必要がある。
                //     一方で、convertExceptionSchedulesFromJST(), preparePostSchedules() 等ほかの場面では
                //     start, end それぞれにおける時差としないと不正な動作になるパターンもあり、そのあたりのロジック制御が大変厳しい。
                // }
            },

            /**
             * 連携Googleカレンダー変更時
             */
            changeLinkCalendar: async function () {
                if (this.inProgress) return
                this.inProgress = true

                await this.fetchMe()
                await this.fetchExceptionSchedules()
                this.bindFullCalendar()

                this.inProgress = false
            },

            /**
             * カレンダー上のイベント押下時
             * @param {object} data
             */
            onEventClick: function (data) {
                if (!data.event.extendedProps.is_google_event) return

                const startFormat = moment(data.event.start).format('HH:mm')
                const endFormat = moment(data.event.end).format('HH:mm')

                this.googleEvent = {
                    title: data.event.title,
                    start: this.timeForHuman(startFormat),
                    end: this.timeForHuman(endFormat),
                    isAllDay: startFormat === '00:00' && endFormat === '00:00',
                    summary: data.event.extendedProps.summary,
                }
                this.eventModalShow = true
            },

            /**
             * Googleカレンダー連携休診の詳細モーダル用フォーマット
             * @param {object} googleEvent
             * @return {string}
             */
            googleEventModalFormat: function (googleEvent) {
                // DSTと冬時間の切り替わり丁度の時間がfullcalendarに登録されたタイミングで start / end どちらかの時間が空になるケースがある
                // 例: シドニー時間 2025-04-06 02:00 - 03:00
                const hasStart = googleEvent.start !== '午前' && googleEvent.start !== '午後'
                const hasEnd = googleEvent.end !== '午前' && googleEvent.end !== '午後'

                if (hasStart && hasEnd) {
                    return `${googleEvent.start} - ${googleEvent.end} 休診`
                }
                const format = hasStart ? googleEvent.start : googleEvent.end
                return `${format} - ${format} 休診`
            },
        },

        computed: {
            /**
             * 相談時間の間隔インデックス（0=15分, 1=30分, 2=60分）
             *
             * @return {number}
             */
            intervalIdx: function () {
                return constants.minutes_intervals.findIndex((interval) => interval === this.doctor.minutes_interval)
            },

            /**
             * 設定中スケジュールのフィルタリング
             * @return {array}
             */
            filteredSchedules: function() {
                // 選択日と一致するスケジュールのみを抽出
                return this.exceptionSchedules.filter((schedule) => {
                    return schedule.schedule_date.substring(0, 10) === this.selectedDate.format('YYYY-MM-DD')
                })
            },

            /**
             * 設定中スケジュールのフィルタリング（Googleカレンダーから連携された休診のみ）
             * @return {array}
             */
            filteredGoogleSchedules: function() {
                // 選択日と一致するスケジュールのみを抽出
                return this.exceptionSchedules.filter((schedule) => {
                    return schedule.is_google_event
                        && schedule.schedule_date.substring(0, 10) === this.selectedDate.format('YYYY-MM-DD')
                })
            },

            /**
             * 設定中スケジュールのフィルタリング（休診のみ）
             * @return {array}
             */
            filteredCloseSchedules: function() {
                // 選択日と一致するスケジュールのみを抽出
                return this.exceptionSchedules.filter((schedule) => {
                    return !schedule.is_google_event
                        && schedule.flg_close === 1
                        && schedule.schedule_date.substring(0, 10) === this.selectedDate.format('YYYY-MM-DD')
                })
            },

            /**
             * 終日休診判定
             * @return {boolean}
             */
            isClosedAll: function () {
                const start = this.filteredSchedules.find((schedule) => schedule.flg_close === 1 && schedule.start_time === '00:00:00')
                const end = this.filteredSchedules.find((schedule) => schedule.flg_close === 1 && schedule.end_time === '24:00:00')
                return start && end && start.id === end.origin_schedule_id
            },
        }
    }
</script>

<style lang="scss">
#modalExceptionSchedule {
    .nav-item {
        .nav-link {
            background: #fff;
        }

        &:nth-child(1) {
            .nav-link.active {
                color: #fff;
                background: #41CD84;
            }
        }

        &:nth-child(2) {
            .nav-link.active {
                color: #fff;
                background: #FB6F78;
            }
        }
    }
}

.vc-exception-schedule-table {
    .b-table-wrapper {
        width: 100%;
        height: 530px;
        overflow-y: scroll;

        .b-table {
            th {
                text-align: center;
            }

            span.status {
                display: block;
                text-align: center;
            }

            span.status-open {
                background: transparent;
            }

            span.status-close {
                padding: 2px 0 0 0;
                font-size: .75rem;
                color: #fff;
                background: #41CD84;
                border-radius: 4px;
            }

            span.status-google {
                padding: 2px 0 0 0;
                font-size: .75rem;
                color: #696C6A;
                background: #D9D9D9;
                border-radius: 4px;
            }
        }
    }

    .base_schedule {
        position: relative;
        top: -1px;
        margin-bottom: 7px;
        padding: 2px 5px;
        color: #fff;
        font-size: 0.78rem;
        text-align: center;
        border: none;
        border-radius: 4px;
        box-sizing: border-box;
        background: #FB6F78;
    }

    .base_schedule_remark {
        display: flex;
        align-items: center;
        margin: 0 0 5px 10px;
        min-width: 100px;

        div:nth-child(1) {
            width: 16px;
            height: 12px;
            background: #FB6F78;
            border-radius: 4px;
        }

        div:nth-child(2) {
            font-size: .7rem;
        }
    }

    .fc-event-container {
        .status {
            padding: 4px 0;
            color: #fff;
            font-size: .7rem;
            font-weight: bold;
            text-align: center;
            border: none;
            border-radius: 4px;
            box-sizing: border-box;
        }

        .status-open {
            background: #FB6F78;
        }

        .status-close {
            background: #41CD84;
        }

        .status-google {
            background: #D9D9D9;
            color: #696C6A;
        }

        .fc-time {
            display: none;
        }
    }
}
</style>

<style scoped>
.modal-account {
    font-size: 18px;
    color: #52A399;
}
.modal-time {
    font-size: 16px;
    font-weight: bold;
}
.modal-summary {
    font-size: 14px;
}
</style>
